import {
  _sharedActionsConstantsMainTree,
  _sharedActionsMainTree
} from "@/shared/store/mainTree/actions";

export const mainTreeActionConstants = {
  ..._sharedActionsConstantsMainTree,
  FETCH_MAIN_TREE_ALL_DATA: "FETCH_MAIN_TREE_ALL_DATA",
};

export const mainTreeActions = {
  ..._sharedActionsMainTree,
  fetchMainTreeAllData: (data) => ({
    type: mainTreeActionConstants.FETCH_MAIN_TREE_ALL_DATA,
    data
  }),
};
